/**
 * Injects and autoplays a YouTube video in a specified container using Video.js.
 * @param {string} containerId - The ID of the DOM element where the video player will be injected.
 * @param {string} youtubeVideoId - The ID of the YouTube video to play.
 */
function playYouTubeInModal(containerId, youtubeVideoId, posterUrl) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error("Modal container not found!");
        return;
    }

    // Clear any previous video player from the container
    container.innerHTML = "";

    // 1. Create a new video element
    const videoEl = document.createElement("video");
    videoEl.id = "dynamic-video-player"; // Assign a temporary ID
    videoEl.className = "video-js vjs-fluid"; // vjs-fluid makes it responsive

    // Add attributes required for inline playback on iOS
    videoEl.setAttribute('playsinline', '');
    videoEl.setAttribute('webkit-playsinline', ''); // For older iOS safari

    // Accessibility: These are not needed. Video.js will manage the accessibility of the player.
    // videoEl.setAttribute("tabindex", "-1");
    // videoEl.setAttribute("aria-hidden", "true");
    // 2. Append the new element to your modal's container
    container.appendChild(videoEl);


    // 3. Define the Video.js options
    const videoOptions = {
        techOrder: ["youtube"],
        sources: [
            {
                type: "video/youtube",
                src: `https://www.youtube.com/watch?v=${youtubeVideoId}`,
            },
        ],
        ...(posterUrl && { poster: posterUrl }),
        autoplay: true,
        muted: false, // Note: iOS may still block unmuted autoplay.
        controls: true,
        playsinline: true, // Explicitly tell Video.js to respect inline playback
        youtube: {
            iv_load_policy: 3,
            ytControls: 0,
        },
    };

    // 4. Initialize the player on the new element
    const player = videojs(videoEl, videoOptions);

    // When the player is ready, apply the focus trap
    player.ready(function () {
        // No action needed here anymore. The trap was set in openModal().
    });

    return player;
}

jQuery(document).ready(function($) {
    // Use a delegated event handler for elements with data-video-id
    // This ensures that the click event is captured correctly.
    $(".watch-for-video").on("click", "[data-video-id]", function (e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling up and causing conflicts

        let videoId = $(this).data("video-id");
        let posterUrl = $(this).data("poster-url");

        if (!videoId) return;

        // Call openModal() immediately to ensure it's tied to the user's click event
        openModal();

        // Now, inject the content container into the already-opening modal
        $(".modal-window__target").html(
            '<div id="my-modal-body" class="video-modal__content"></div>',
        );

        // Finally, initialize the video player in the new container
        playYouTubeInModal("my-modal-body", videoId, posterUrl || null);
    });
});

